import { RouteConfigComponentProps, renderRoutes } from 'react-router-config';

const Advertisement = ({ route }: RouteConfigComponentProps) => {
  return <div>{renderRoutes(route?.routes)}</div>;
};

export default Advertisement;
